import { defer } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';

import Icon from '../../../../elements/icons/Icon';
import styles from './BubblesFilter.module.scss';

const FilterButton = props => {
    const {event, active = false, className = '', children = null, icon, onClick, onMouseOver, onMouseEnter} = props,
        [isActive, setActive] = useState(active);

    useEffect(() => {
        setActive(active);
    }, [active]);

    const handleClick = useCallback(() => {
        setActive(!isActive);
        if (onClick) defer(onClick)
    }, [isActive, onClick]);

    return (
        <button
            className={[className, isActive ? styles.active : ''].join(' ')}
            type="button"
            onClick={handleClick}
            onMouseEnter={onMouseEnter}
            onMouseOver={onMouseOver}>
            <Icon className={styles.whiteBg} src={icon} color={event.settings.secondary_color} />
            <Icon className={styles.colorBg} src={icon} color="white" />
            {children}
        </button>
    );
};

export default FilterButton;
